import { Injectable, NgZone } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, exhaustMap, catchError, tap, withLatestFrom, mergeMap, filter, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import * as fromVoucherActions from '../actions/voucher.actions';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.state';
import { ErrorService } from '../../services/error.service';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.actions';
import { AccountService } from 'src/app/services/account.service';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { RouterNavigatedAction, ROUTER_NAVIGATION } from '@ngrx/router-store';
import { APIResponse } from 'src/app/models/api-response.model';
import { SuccessComponent } from 'src/app/shared/modals/success/success.component';
import { autoLogout } from '../actions/auth.actions';
import { ErrorComponent } from 'src/app/shared/modals/error/error.component';
import { VoucherService } from 'src/app/services/voucher.service';
@Injectable()
export class VoucherEffects {
  getVoucherList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromVoucherActions.getVoucherList),
      mergeMap(() => {
        return this.voucherService.getVoucherList().pipe(
          map((response: APIResponse) => {
            console.log('getVoucherList$', response);
            // Same shape as voucherList$: the list is paginated, so it has no `details`.
            return fromVoucherActions.getVoucherListSuccess({ data: response });
          })
        );
      })
    )
  );

  voucherList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/dashboard');
      }),
      mergeMap(() => {
        return this.voucherService.getVoucherList().pipe(
          map((response: APIResponse) => {
            console.log('voucherList$', response);
            return fromVoucherActions.getVoucherListSuccess({ data: response });
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private voucherService: VoucherService,
    private modalController: ModalController,
    private navCtrl: NavController,
  ) { }
}
